export default __webpack_public_path__ + "static/support-sailors-111911d5d11cb38aea495aa29e69c3eb.jpg";